<template>
    <div
        class="pop_banner"
        v-show="state.isShow"
        :style="{ display: 'block', zIndex: 99 - state.item.orderNo }"
        :class="state.item.location == 'L' ? 'pop_left' : state.item.location == 'M' ? 'pop_middle' : 'pop_right'"
    >
        <div class="pop_banner_tit">
            <p>{{ state.item.title }}</p>
        </div>

        <div
            class="content_wrap icon_wrap"
            @click="state.item.link && moveLink(state.item.link)"
            :style="{ cursor: state.item.link ? 'pointer' : 'default' }"
        >
            <img :src="state.item.file" @error="imgError" />
        </div>
        <div class="pop_btn_wrap">
            <div class="close_btn checkbox_wrap">
                <label :for="state.item.idx" v-if="state.item.isSettingClose === 1">
                    <input type="checkbox" :id="state.item.idx" @change="state.isNoShowToday = !state.isNoShowToday" />
                    <em></em>
                    <span class="no_blue">오늘 하루 안보기</span>
                </label>
            </div>
            <button class="close_btn icon_wrap" @click="fnEvent">닫기</button>
        </div>
    </div>

    <!-- 팝업 -->
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, popupStore } from "@/BaseComponent";

    export default {
        props: {
            item: {
                type: Object,
                default: {},
            },
        },

        setup(props: any, { emit }: any) {
            const popup = popupStore();
            const state = reactive({
                item: {} as any,
                isShow: false as boolean,
                isNoShowToday: false as boolean,
            });

            onMounted(() => {
                state.item = props.item;
                state.isShow = true;
                state.isNoShowToday = false;
            });

            onUnmounted(() => {});

            const fnEvent = () => {
                state.isShow = false;

                if (state.isNoShowToday) popup.hidePopupForToday(state.item.idx);
            };

            const moveLink = (link: string) => {
                window.open(link, "_blank"); // 새 창에서 이동
            };

            const imgError = (e: Event) => {
                const target = e.target as HTMLImageElement;
                if (target) {
                    target.src = require("@/assets/no_img.png");
                }
            };
            return { state, fnEvent, props, moveLink, imgError, popup };
        },
    };
</script>
